<div [cfaLoading]="isLoading">
  <form [formGroup]="networkForm">
    <mat-card>
      <mat-card-header>
        <mat-card-title>Network</mat-card-title>
      </mat-card-header>
      <mat-divider></mat-divider>
      <mat-card-content>
        <div class="form-field-wrapper">
          <mat-form-field appearance="outline">
            <mat-label>Name</mat-label>
            <input matInput formControlName="name">
            @if (networkForm.get('name').hasError('pattern')) {
              <mat-error>
                Please enter a 5 digit store number
              </mat-error>
            }
            @if (networkForm.get('name').hasError('maxLength')) {
              <mat-error>
                Please enter a 5 digit store number
              </mat-error>
            }
            @if (networkForm.get('name').hasError('minLength')) {
              <mat-error>
                Please enter a valid 5 digit store number
              </mat-error>
            }
          </mat-form-field>
        </div>
        <div class="form-field-wrapper">
          <mat-form-field appearance="outline">
            <mat-label>Tags</mat-label>
            <input matInput formControlName="tags">
            @if (networkForm.get('tags').hasError('required')) {
              <mat-error>
                Please enter a space separated list of tags
              </mat-error>
            }
          </mat-form-field>
        </div>
        <div class="form-field-wrapper">
          <mat-form-field appearance="outline">
            <mat-label>Type</mat-label>
            <input matInput formControlName="type">
            @if (networkForm.get('type').hasError('required')) {
              <mat-error>
                Please enter a valid type
              </mat-error>
            }
          </mat-form-field>
        </div>
        <div class="form-field-wrapper">
          <mat-form-field appearance="outline">
            <mat-label>Template</mat-label>
            <mat-select>
              @for (template of configTemplates; track template) {
                <mat-option (onSelectionChange)="handleConfigTemplateSelection($event)"
                  [value]="template.id">
                  {{template.name}}
                </mat-option>
              }
            </mat-select>
            @if (networkForm.get('template').hasError('required')) {
              <mat-error>
                Please enter a valid template
              </mat-error>
            }
          </mat-form-field>
        </div>
      </mat-card-content>
    </mat-card>
  </form>
</div>